export const FORCE_EMIT_NAVIGATION_EVENT_QUERY_PARAM = 'reload-route';
